import { put, takeLatest, call } from 'redux-saga/effects';
import {
  GET_CLIENT_FILES,
  UPLOAD_CLIENT_FILE,
  DELETE_CLIENT_FILE,
} from './constants';
import {
  getClientFilesSuccess,
  getClientFilesError,
  uploadClientFileSuccess,
  uploadClientFileError,
  deleteClientFileSuccess,
  deleteClientFileError,
} from './actions';
import { fetchData } from '../api';

function authConfig(method = 'GET', body) {
  const config = {
    method,
    headers: {
      'x-auth-token': window.localStorage.token,
      'Content-Type': 'application/json',
    },
  };
  if (body !== undefined) config.body = JSON.stringify(body);
  return config;
}

export function* getClientFiles({ clientId }) {
  try {
    const url = `${process.env.REACT_APP_API_URL}/api/admin/files/${clientId}`;
    const data = yield call(fetchData, url, authConfig());
    yield put(getClientFilesSuccess(data));
  } catch (err) {
    let error = err;
    try {
      error = yield err.json();
    } catch (_) {
      // err wasn't a Response
    }
    yield put(getClientFilesError(error));
  }
}

export function* uploadClientFile({ payload }) {
  try {
    const { clientId, ...body } = payload;
    const url = `${process.env.REACT_APP_API_URL}/api/admin/files/${clientId}`;
    const data = yield call(fetchData, url, authConfig('POST', body));
    yield put(uploadClientFileSuccess(data));
  } catch (err) {
    let error = err;
    try {
      error = yield err.json();
    } catch (_) {
      // err wasn't a Response
    }
    yield put(uploadClientFileError(error));
  }
}

export function* deleteClientFile({ fileId }) {
  try {
    const url = `${process.env.REACT_APP_API_URL}/api/admin/files/${fileId}`;
    yield call(fetchData, url, authConfig('DELETE'));
    yield put(deleteClientFileSuccess(fileId));
  } catch (err) {
    let error = err;
    try {
      error = yield err.json();
    } catch (_) {
      // err wasn't a Response
    }
    yield put(deleteClientFileError(error));
  }
}

export default function* sharedFileSaga() {
  yield takeLatest(GET_CLIENT_FILES, getClientFiles);
  yield takeLatest(UPLOAD_CLIENT_FILE, uploadClientFile);
  yield takeLatest(DELETE_CLIENT_FILE, deleteClientFile);
}
